// @ts-nocheck
import React from 'react';
import API from 'utils/API';
import Head from 'next/head';

const api = new API();
import Blog from 'app/features/Blog';

const WrappedBlog = ({ blogs, totalPages, langCode }) => {
  return (
    <>
      <Head>
        <title>Pandaist Blog - Learn Chinese by Reading</title>
        <meta name="description" content="Learn Chinese by Reading" />
        <link rel="canonical" href="https://pandaist.com/blog/en" />
        <link rel="next" href="https://pandaist.com/blog/en?page=2" />
        <meta name="twitter:description" content="Learn Chinese by Reading" />
        <meta property="og:locale" content="en_US" />
        <meta
          property="og:site_name"
          content="Pandaist Blog | Learn Chinese by Reading"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Pandaist Blog | Learn Chinese by Reading"
        />
        <meta property="og:description" content="Learn Chinese by Reading" />
        <meta property="og:url" content="https://pandaist.com/blog/en" />
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:title"
          content="Pandaist Blog | Learn Chinese by Reading"
        />
      </Head>
      <Blog blogs={blogs} totalPages={totalPages} langCode={langCode} />
    </>
  );
};

export async function getServerSideProps({ params, query }) {
  const langCode = params?.lang_code || 'en';
  const currentPage = query.page || 1;

  let response;
  try {
    response = await api.get('blogsAPI', {
      query: { published: 1, page: currentPage, lang_code: langCode },
      params: null,
      body: {},
    });

    const totalPages = response.data.total_pages;
    const blogs = response.data.results;

    if (!blogs) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        blogs,
        totalPages,
        langCode,
      },
    };
  } catch (error) {
    console.error('Error fetching blogs:', error);
    return {
      props: {
        blogs: [],
        totalPages: 0,
        langCode,
      },
    };
  }
}

export default WrappedBlog;
